module.exports = __webpack_public_path__ + "static/media/thawte@2x.1a1f6f86.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/sobrePedraza/compra-segura/thawte@2x.png
// module id = 246
// module chunks = 0